export default "__VITE_ASSET__UqOIrN20__"